import script from "./SpeakText.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeakText.vue?vue&type=script&setup=true&lang=js"

import "./SpeakText.vue?vue&type=style&index=0&id=5c7bc982&lang=css"

const __exports__ = script;

export default __exports__